// Date, currency and slug formatting. .tsx because formatTitleWithItalic returns JSX.
export const convertDateFormat = dateStr => {
  const date = new Date(dateStr)
  // Extract day, month, and year
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // getMonth() is zero-based
  const year = date.getFullYear()

  return `${day}/${month}/${year}`
}

export const CurrencyFormatter = value => {
  const formattedValue = value?.toLocaleString('en-US')

  return formattedValue
}

export const formatTitleWithItalic = title => {
  const parts = title?.split('-i')
  if (parts?.length === 2) {
    return (
      <>
        {parts[0]}-<i>i</i>
        {parts[1]}
      </>
    )
  }
  return title
}

export const convertMonthEnglishFormat = dateStr => {
  const date = new Date(dateStr)
  // Extract day, month, and year
  const day = String(date.getDate()).padStart(2, '0')
  const month = date.toLocaleString('default', { month: 'long' })
  const year = date.getFullYear()

  return `${day} ${month} ${year}`
}

export const generateSlug = value => {
  const result = value
    .toLowerCase()
    .replaceAll(/[^a-z0-9]+/g, '-')
    .replaceAll(/^-+|-+$/g, '')

  return result
}

export const formatCurrency = value => {
  // Format value with commas
  let formattedValue = ''
  if (value) {
    formattedValue = value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }
  return formattedValue
}

export const formatInt = value => {
  const num = Number(value)
  if (!Number.isFinite(num)) return
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(num)
}
